module.exports = __webpack_public_path__ + "media/images/logo_name_white-3616e88a.png";